import React, { useState } from 'react';

import { ButtonBase, InputLabel, Menu, Stack } from 'components';
import { Add, CloseCircle } from 'iconsax-react';

import { Picker } from './Picker';

import { palette } from 'styles/theme';

const BUTTON_SX = {
  border: '1px solid',
  borderColor: 'cadet.400',
  width: 32,
  height: 32,
  borderRadius: '4px',
  bgcolor: '#FFFFFF',
};

type Props =
  | {
      nullable: true;
      label: string;
      onChange: (value: string | null) => void;
      defaultValue: string | null;
    }
  | {
      nullable: false;
      label: string;
      onChange: (value: string) => void;
      defaultValue: string;
    };

export const BaseColorInput: React.FC<Props> = ({
  label,
  defaultValue,
  onChange,
  nullable,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [value, setValue] = useState(defaultValue);
  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const renderResetButton = () => {
    if (!nullable) {
      return null;
    }
    if (typeof value !== 'string' || value.trim().length === 0) {
      return null;
    }
    return (
      <ButtonBase
        onClick={() => {
          setValue(null);
          onChange(null);
        }}
      >
        <CloseCircle variant="TwoTone" size="20" color={palette.grey600} />
      </ButtonBase>
    );
  };

  const renderOpenButton = () => {
    if (value) {
      return (
        <ButtonBase
          onClick={handleClickOpen}
          sx={{ ...BUTTON_SX, bgcolor: value }}
        />
      );
    }
    return (
      <ButtonBase onClick={handleClickOpen} sx={{ ...BUTTON_SX }}>
        <Add variant="TwoTone" size="20" />
      </ButtonBase>
    );
  };

  return (
    <Stack alignItems="flex-start">
      <InputLabel sx={{ mb: 0.5 }}>{label}</InputLabel>
      <Stack direction="row" spacing={1}>
        {renderOpenButton()}
        {renderResetButton()}
      </Stack>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          sx: { height: 'auto', padding: 0 },
        }}
      >
        <Picker
          value={value || ''}
          onChange={v => {
            setValue(v);
            onChange(v);
          }}
        />
      </Menu>
    </Stack>
  );
};
